export const SettingTabsKeys = Object.freeze({
    Profile: 'profile',
    Plan: 'plan',
    Esigning: 'esigning',
    Api: 'api',
});
